/** Single Firebase / Maps config for every build (dev vs prod is only Angular compile options). */
export const environment = {
  production: false,
  /** Angular service worker (PWA). */
  serviceWorker: true,
  useEmulators: false,
  functionsRegion: 'australia-southeast2',
  firebase: {
    apiKey: 'AIzaSyCq9eLi19bvzYrPh6NIUMu7a70DbhL0T7Q',
    authDomain: 'training-guide-a9c82.firebaseapp.com',
    projectId: 'training-guide-a9c82',
    storageBucket: 'training-guide-a9c82.firebasestorage.app',
    messagingSenderId: '43345769761',
    appId: '1:43345769761:web:c2c7aa55db3f6fa05aba60',
    measurementId: 'G-7XZ7LMKLMP',
  },
  /** Google Maps JavaScript API key (Places + Maps JS). Restrict by referrer / Android package + SHA1. */
  mapsApiKey: 'AIzaSyDNJoAOJ_5gIk936QVwIePkTxGdtzBbO_E',
  /**
   * Map ID from Google Cloud → Google Maps Platform → Map Management (vector map).
   * Required for `map-advanced-marker` pins; leave empty to show the map without markers.
   */
  mapsMapId: '',
};
